import { fetchAllBeneficiaries } from '@api/beneficiaries';
import { queryClient } from '@basqet-dashboard/common/config';
import { generatedDates } from '@basqet-dashboard/common/utils';
import { useEffect, useState } from 'react';
import { useInfiniteQuery } from 'react-query';
import { toast } from 'react-toastify';

const useFetchBeneficiaries = ({ grouped = false, singles_only = false, dropdown = false }) => {
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilter, setDateFilter] = useState({ from: '', to: '' });
  let recentBeneficiaries = [];

  const {
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    isError,
    error,
    data,
    refetch,
    isRefetching,
    isLoading
  } = useInfiniteQuery(
    'allBeneficiaries',
    ({ pageParam }) => {
      return fetchAllBeneficiaries({
        offset: pageParam,
        searchQuery,
        dateFilter,
        grouped,
        singles_only
      });
    },

    {
      getNextPageParam: (lastPage) => {
        const hasNext = lastPage.meta?.hasNext;
        const lastBeneficiary = lastPage && lastPage.data[lastPage.data.length - 1];
        return hasNext ? lastBeneficiary && lastBeneficiary.id : undefined;
      }
    }
  );
  if (isError) {
    toast.error('Error fetching beneficiaries');
  }

  useEffect(() => {
    if (data && data.pages) {
      let aggregatedBeneficiaries = [];

      if (dropdown) {
        aggregatedBeneficiaries = [
          ...aggregatedBeneficiaries,
          { address: '0', alias: 'New Beneficiary', currency_slug: '' }
        ];
      }
      data.pages.map(({ data: beneficiariesList }) => {
        aggregatedBeneficiaries = [...aggregatedBeneficiaries, ...beneficiariesList];
      });

      setBeneficiaries(aggregatedBeneficiaries);
    }
  }, [data]);
  recentBeneficiaries = beneficiaries.slice(0, 4);

  useEffect(() => {
    reloadBeneficiaries();
  }, [dateFilter, searchQuery]);

  const filterByDate = (dateType) => {
    if (dateType) {
      setDateFilter({ from: generatedDates[dateType](), to: generatedDates.now() });
    } else {
      setDateFilter({ from: null, to: null });
    }
  };

  const reloadBeneficiaries = () => {
    setBeneficiaries([]);
    queryClient.removeQueries('allBeneficiaries', { exact: true });
    refetch({ resetQueries: true });
  };

  return {
    recentBeneficiaries,
    beneficiaries,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    searchQuery,
    setSearchQuery,
    isRefetching,
    isLoading,
    refetch,
    filterByDate,
    error
  };
};

export { useFetchBeneficiaries };
